import { React, useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import servicesApi from '../../seller-apis/servicesApi';
import '../../assets/css/enquirycard.css'

function EnquiryCard(props) {


  // Detail new

  function detailnew(url) {
    
    let data =
    {
      "filter": { "urlKey": url }
    }
    servicesApi.getProductDetail(data).then((res) => {
      props.pdetail([res.data], props.price)
      props.popupdetailVis("2");
    }).catch(err => console.log(err))

  }



 if (props.spcl === "noProDetail") {
    
    return (
      <>
         <tr className='fs-14 f-700 color-row ord_table_row'>
            <td className='order_table_date'>{props.enquiryId || "-"}</td>
            <td className='order_table_date'> {props.date}</td>
            <td className='td-img-cntn'>-</td>
            <td className='order_table_price'>
              -
            </td>
            <td className='order_table_price'> - 
            </td>
            <td>
              -
            </td>
          </tr>
      </>
    )
  }
  else {

    // New Enquiries
    if (props.status === "PENDING") {
      return (
        <>
          <tr className='fs-14 f-700 color-row ord_table_row'>
            <td className='order_table_date'>{"60a2" + props.enquiryId}</td>
            <td className='order_table_date'> {props.date}</td>
            <td className='td-img-cntn'> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" /></td>
            <td className='enquiry_table_pname_cntn'>
              {props.from === "home" ?
                <>
                  <a href='#popup3' onClick={() => detailnew(props.urlKey)}>
                    <span className="f-500">{props.productName}</span>
                    </a>
                    <br></br>
                    <span className="order-Price fs-11"> (Quantity: {props.quantity})</span>
                 
                  <div className="enq-card-comb-div">
                    {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                      return (
                        <>
                          <span className="enq-card-comb-span" key={index}><span className='ff_pop'>{props.combination[index]}</span><span className='ff_pop'> : {item}</span></span>
                        </>
                      )
                    }) : <></>}

                  </div>
                </>
                : <>
                  <a href='#popupDetail' onClick={() => detailnew(props.urlKey)}>
                    <span className="f-500 ">{props.productName}</span>
                    </a>
                    <br></br>
                    <span className="order-Price fs-11"> (SKU: {props.SKU})</span>
                    <br></br>
                    <span className="order-Price fs-11"> (Quantity: {props.quantity})</span>
                 
                  <div className="enq-card-comb-div">
                    {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                      return (
                        <>
                          <span className="enq-card-comb-span" key={index}><span className='ff_pop'>{props.combination[index]}</span><span className='ff_pop'> : {item}</span></span>
                        </>
                      )
                    }) : <></>}

                  </div>
                </>
              }
            </td>
            <td className='order_table_price'><i class="fa fa-inr" aria-hidden="true"></i> {props.price}
            </td>
            <td>
              
              <p className='ff_pop'>Is this product available ?</p>
              <div className='flex text-center'>
                <button className='enquiry_action_btn enquiry_yes_btn' onClick={() => props.approve(props.productId, "approve",props.pId,props?.selSubPrdValObj,props?.id)}>Yes</button>
                <button className='enquiry_action_btn enquiry_no_btn' onClick={() => props.disapprove(props.productId, "disapprove")}>No</button>
              </div>
            </td>
          </tr>

        </>
      )
    }


    // Enquiry history
    else {
      return (
        <>
          <tr className='fs-14 f-700 color-row ord_table_row'>
            <td className='order_table_date'>{"60a2" + props.enquiryId}</td>
            <td className='order_table_date'> {props.date}</td>
            <td className='td-img-cntn'> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" /></td>
            <td className='enquiry_table_pname_cntn'>
              
                <a href='#popupDetail' onClick={() => detailnew(props.urlKey)}>
                  <span className="f-500 ">{props.productName}</span>
                  </a>
                  <br></br>
                  <span className="order-Price fs-11"> (Quantity: {props.quantity})</span>
                
                <div className="enq-card-comb-div">
                  {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                    return (
                      <>
                        <span className="enq-card-comb-span" key={index}><span className='ff_pop'>{props.combination[index]}</span><span className='ff_pop'> : {item}</span></span>
                      </>

                    )
                  }) : <></>}


                </div>
            </td>
            <td className='order_table_price'><i class="fa fa-inr" aria-hidden="true"></i> {props.price}
            </td>
            <td>
              {props.status}
            </td>
          </tr>

        </>
      )
    }

  }
}
export default EnquiryCard;